import CountryPageRenderer from '../components/CountryPageRenderer';
import uaeData from '../data/country-pages/united-arab-emirates';

export default function UAECountryPage() {
  return <CountryPageRenderer data={uaeData} />;
}
